import { Button, Col, InputNumber, message, Popconfirm, Row, Select, Table } from 'antd'
import { Input } from 'antd/lib/index'
import _ from 'lodash'
import moment from 'moment'
import React, { Component, Fragment } from 'react'
import { getOrdinal } from '../../../../../../modules/Utils'

const Option = Select.Option
const InputGroup = Input.Group

const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? <Input style={{ width: 50 }} value={value} onChange={(e) => onChange(e.target.value)} /> : value}
  </div>
)
const EditableCellDays = ({ editable, value, onChange, type }) => (
  <div>
    {editable ? (
      <InputNumber min={1} max={1000} style={{ width: 100 }} value={value} onChange={(value) => onChange(value)} />
    ) : (
      `${value ? value : ''} ${value && type}`
    )}
  </div>
)

const EditableCellYears = ({ editable, value, onChange, type }) => (
  <div>
    {editable ? (
      <InputNumber min={1} max={1000} style={{ width: 100 }} value={value} onChange={(value) => onChange(value)} />
    ) : (
      `${value ? getOrdinal(value) : ''} ${value && type}`
    )}
  </div>
)

class Annual extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    let { data, rollover } = this.props
    if (!_.isEmpty(data)) data = data.map((item) => ({ ...item }))
    data.forEach((i) => {
      if (!i.key) i.key = (this.uuid++).toString()
    })
    this.cacheData = data.map((item) => ({ ...item }))
    this.state = { isRoll: rollover > 0, rollover: rollover, data }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      let { data, rollover } = this.props
      if (!_.isEmpty(data)) data = data.map((item) => ({ ...item }))
      data.forEach((i) => {
        if (!i.key) i.key = (this.uuid++).toString()
      })
      this.cacheData = data.map((item) => ({ ...item }))
      this.setState({ isRoll: rollover > 0, rollover: rollover, data })
    }
  }

  columns = [
    {
      title: 'Working Year',
      dataIndex: 'years',
      render: (text, record) => this.renderColumnsNumbers(text, record, 'years', 'Year'),
    },
    {
      title: 'Entitled Annual leaves ',
      dataIndex: 'days',
      render: (text, record) => this.renderColumnsNumbers(text, record, 'days', 'Days'),
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => {
        const { editable } = record
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => this.save(record.key)}>Save</a>
                <span className="ant-divider" />
                <Popconfirm title="Sure to cancel?" onConfirm={() => this.cancel(record.key)}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <a onClick={() => this.edit(record.key)}>Edit</a>,
                <span className="ant-divider" />,
                <Popconfirm title="Sure to remove?" onConfirm={() => this.remove(record.key)}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]
  add = () => {
    const newData = [...this.state.data]
    newData.push({ key: (this.uuid++).toString(), editable: true })
    this.setState({ data: newData })
  }

  cancel(key) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (!_.isEmpty(target)) {
      Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
      delete target.editable
      if (Object.keys(target).length === 1 && Object.keys(target)[0] === 'key') this.remove(target.key)
      else this.setState({ data: newData })
      this.props.updateContract('annual', newData)
    }
  }

  remove(key) {
    let newData = [...this.state.data]
    newData = newData.filter((item) => key !== item.key)
    this.setState({ data: newData })
    this.props.updateContract('annual', newData)
  }

  edit(key) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      target.editable = true
      this.setState({ data: newData })
      this.props.updateContract('annual', newData)
    }
  }

  save(key) {
    const newData = [...this.state.data]
    const target = newData.find((item) => key === item.key)
    if (target) {
      const year = newData.find((item) => target.years === item.years && item.editable !== true)
      if (year) message.error('Condition existed!')
      else if (!(target.years && target.days)) message.error('Invalid Data')
      else {
        delete target.editable
        this.setState({ data: newData })
        this.cacheData = newData.map((item) => ({ ...item }))
        this.props.updateContract('annual', newData)
      }
    }
  }

  handleChange(value, key, column) {
    const newData = [...this.state.data]
    const target = newData.filter((item) => key === item.key)[0]
    if (target) {
      target[column] = value
      this.setState({ data: newData })
    }
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.editable}
        value={text}
        onChange={(value) => this.handleChange(value, record.key, column)}
      />
    )
  }

  renderColumnsNumbers(text, record, column, type) {
    return column === 'years' ? (
      <EditableCellYears
        editable={record.editable}
        value={text}
        type={type}
        onChange={(value) => this.handleChange(value, record.key, column)}
      />
    ) : (
      <EditableCellDays
        editable={record.editable}
        value={text}
        type={type}
        onChange={(value) => this.handleChange(value, record.key, column)}
      />
    )
  }

  render() {
    const { type } = this.props
    if (type === 'view') this.columns = this.columns.filter((c) => c.dataIndex !== 'operation')

    return (
      <Fragment>
        <Row>
          <Col span={12}>
            <p
              style={{
                fontWeight: 'bold',
                textAlign: 'right',
                paddingRight: 10,
                paddingTop: 5,
              }}>
              Can this entitlement be rolled over?
            </p>
          </Col>
          <Col span={12}>
            <InputGroup compact>
              <Select
                value={this.state.isRoll}
                onChange={(value) => {
                  this.setState({ isRoll: value, rollover: 0 })
                  this.props.updateContractRollover('annual', 0)
                }}
                defaultValue="NO">
                <Option value={false}>NO</Option>
                <Option value={true}>YES</Option>
              </Select>
              <InputNumber
                value={this.state.rollover}
                onChange={(value) => {
                  this.props.updateContractRollover('annual', value)
                  this.setState({ rollover: value })
                }}
                style={{ width: '50px' }}
                placeholder="Years"
                disabled={!this.state.isRoll}
              />
            </InputGroup>
          </Col>
        </Row>

        <Table
          title={() => (
            <Fragment>
              <span style={{ color: '#1890ff' }}>Annual Leaves</span>
              {type !== 'view' && (
                <Button style={{ float: 'right' }} size={'small'} onClick={this.add}>
                  Add
                </Button>
              )}
            </Fragment>
          )}
          bordered
          pagination={false}
          dataSource={this.state.data.filter((i) => i.removed !== true)}
          columns={this.columns}
          size="small"
          style={{ marginTop: 10 }}
        />
      </Fragment>
    )
  }
}

export default Annual
